import * as React from 'react';
import { selectUser } from '../../redux/UserSlice';
import { useAppSelector } from '../../hooks';
import NotificationErrorBySections from '../layout/Notification/NotificationErrorBySections';
import { Afr, getSelectedAfr } from '../../redux/AfrSlice';




const DisplayName = () => {
    const userData = useAppSelector(selectUser);
    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);

    //TODO modify to display for entity entity code and name same as loger
    return (
        <React.Fragment>
            {userData != null &&
                userData.userProfile != null ? (
                <div className="d-flex justify-content-end" style={{
                color: "#000",
                textAlign: "right",
                paddingRight: "1rem"
                    }}>
                       <div className="my-2"> <i className="bi text-success bi-person-circle"></i> { userData ? userData.userProfile.firstName + " " + userData.userProfile.lastName
                            : ""}
                       </div>
                        <div>
                            {(currentAfr && currentAfr.status !== "REPORT_MODE" ) && (<NotificationErrorBySections />)}
                        </div>
                </div>) : (<div></div>)}
        </React.Fragment>
    );
}


export default DisplayName;